import React, { useContext } from "react";
import styled from "styled-components";

import { RichContentDisplay } from "@examspark/common-ui";
import { RichContentEditor } from "@examspark/common-ui-rce5";
import { StemTextExtended } from "@examspark/types";

import QuestionContext from "../QuestionContext";

import Prompt from "./shared/Prompt";

const StyledRubric = styled.div`
  background-color: #e1fde5;
  padding: 1rem;
  margin: 1rem 0;

  h3 {
    font-weight: normal;
    text-transform: uppercase;
    color: #518358;
    margin: 0.5rem 0;
    font-size: 1.2rem;
  }
`;

interface ExtendedTextProps {
  data: StemTextExtended;
}

const ExtendedText: React.FC<React.PropsWithChildren<ExtendedTextProps>> = (
  props,
) => {
  const [player, dispatchPlayer] = useContext(QuestionContext);

  return (
    <div className="item-player-element item-player-stem">
      <Prompt data={props.data.content.prompt} />
      <RichContentEditor
        variant="classic"
        value={player?.response?.[props.data.id] || ""}
        onChange={(value) => {
          dispatchPlayer({
            type: "RESPONSE",
            data: {
              id: props.data.id,
              response: value,
            },
          });
        }}
      />
      {player.revealKey && (
        <>
          {props.data.config?.enableRubric && props.data.scoring?.rubric && (
            <StyledRubric>
              <h3>Scoring Rubric</h3>
              <RichContentDisplay content={props.data.scoring.rubric.body} />
            </StyledRubric>
          )}
          {props.data.config?.enableSolution &&
            props.data.scoring?.solution && (
              <StyledRubric>
                <h3>Solution</h3>
                <RichContentDisplay
                  content={props.data.scoring.solution.body}
                />
              </StyledRubric>
            )}
        </>
      )}
    </div>
  );
};
export default ExtendedText;
